module.exports = __webpack_public_path__ + "public/img/banner2.74e175b0.png";